import axiosPost from '../axiosPost';

export const localidadesUpd = async (arg) => {
    const { id, nombre, version } = arg;

    const body = {
        "service": "LocalidadUpd",
        "params": {
            "localidadId": id,
            "localidadNombre": nombre,
            "localidadVersion": version,
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        console.log(result.data)
        return result.data
    } catch (err) {
        console.log(err)
    }
};